<script setup lang="ts">
import { PropType, computed } from 'vue'
import { Criticality } from '../../types/enums'
import type { TravelInfoMessage } from './../../types'
import { getCurrentCulture } from './../../utilities/culture-helper'

const props = defineProps({
  travelInfoMessages: {
    type: Array as PropType<TravelInfoMessage[]>,
    required: true,
  },
})

const showMessages = computed<boolean>(
  () =>
    props.travelInfoMessages.length > 0 &&
    props.travelInfoMessages.some((x) => x.isVisible)
)

const { cultureShortCode } = getCurrentCulture()

function getMessageThemeClass(travelMessage: TravelInfoMessage): string {
  switch (travelMessage.criticality) {
    default:
    case Criticality.Normal:
      return 'accordion__status-svg--success'
    case Criticality.Important:
      return 'accordion__status-svg--warning'
    case Criticality.Critical:
      return 'accordion__status-svg--danger'
  }
}
function getMessageSvgIcon(travelMessage: TravelInfoMessage): string {
  switch (travelMessage.criticality) {
    default:
    case Criticality.Normal:
      return '#svg-check'
    case Criticality.Important:
      return '#svg-warning'
    case Criticality.Critical:
      return '#svg-alert'
  }
}

function showTravelMessage(travelMessage: TravelInfoMessage): boolean {
  return (
    travelMessage.isVisible &&
    travelMessage.title[cultureShortCode]?.length > 0 &&
    travelMessage.message[cultureShortCode]?.length > 0
  )
}
</script>

<template>
  <div
    v-if="showMessages"
    class="accordion accordion--small"
    data-allow-multiple=""
  >
    <template v-for="travelMessage in travelInfoMessages">
      <details
        v-if="showTravelMessage(travelMessage)"
        class="accordion__item"
        open
      >
        <summary class="accordion__summary">
          <svg
            :class="[
              'accordion__status-svg',
              getMessageThemeClass(travelMessage),
            ]"
          >
            <use :xlink:href="getMessageSvgIcon(travelMessage)"></use>
          </svg>
          {{ travelMessage.title[cultureShortCode] }}
          <svg class="accordion__summary-svg">
            <use xlink:href="#svg-expand"></use>
          </svg>
        </summary>
        <div class="accordion__content">
          <div
            class="accordion__text"
            v-html="travelMessage.message[cultureShortCode]"
          ></div>
        </div>
      </details>
    </template>
  </div>
</template>

<style lang="scss" scoped></style>
